import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
// import YouTube from '../../../commons/youtube';
import Lib from '../../../commons/lib';
import PartnerAdatok from './PartnerAdatok';
import Jogalap from './Jogalap';
import FunkcioJogalapOsszerendeles from './FunkcioJogalapOsszerendeles';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../PartnerTooltips';

/* const videoData = [
  { text: 'Számla előkészítés', id: 'ofmciGZYhz4' },
  { text: 'Számla küldés', id: '5ugllRivDZU' }
]; */

class PartnerGDPRBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: undefined
    };
  }

  componentDidMount() {
    this.initTab();
  }

  initTab = () => {
    let activeTab = '1';
    if (this.props.globals.hasRole(['GDPR_JOGALAP'])) activeTab = '4';
    if (this.props.globals.hasRole(['GDPR_JOGALAP'])) activeTab = '3';
    if (this.props.globals.hasRole(['GDPR_JOGALAP'])) activeTab = '2';
    if (this.props.globals.hasRole(['GDPR_PROFIL'])) activeTab = '1';
    this.setState({ activeTab: activeTab });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              {'Partner GDPR'}
              {/* <YouTube data={videoData} /> */}
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {
                    this.props.globals.hasRole(['GDPR_PROFIL']) && 
                    (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        {'Partner adatok'}
                        <CustomTooltip text={getTooltip('partneradat')} id="partneradatTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {
                    this.props.globals.hasRole(['GDPR_JOGALAP']) && 
                    (
                    <React.Fragment>
                      <NavItem>
                        <NavLink
                          href="#"
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => { this.toggle('2'); }}
                        >
                          {'Jogalap'}
                          <CustomTooltip text={getTooltip('jogalap')} id="jogalapTT" />
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          href="#"
                          className={classnames({ active: this.state.activeTab === '3' })}
                          onClick={() => { this.toggle('3'); }}
                        >
                          {'Funkció-jogalap összerendelés'}
                          <CustomTooltip text={getTooltip('funkciojogalap')} id="funkciojogalapTT" />
                        </NavLink>
                      </NavItem>
                    </React.Fragment>
                  )}
                  {/* {this.props.globals.hasRole(['GDPRPROFIL']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '4' })}
                        onClick={() => { this.toggle('4'); }}
                      >
                        Marketing
                      </NavLink>
                    </NavItem>
                  )} */}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {
                    this.props.globals.hasRole(['GDPR_PROFIL']) && 
                    (
                    <TabPane tabId="1">
                      <PartnerAdatok
                        {...this.props}
                        globals={this.props.globals}
                        ref={(instance) => { this.child1 = instance; }}
                        active={this.state.activeTab === '1'}
                      />
                    </TabPane>
                  )}
                  {
                    this.props.globals.hasRole(['GDPR_JOGALAP']) && 
                    (
                    <React.Fragment>
                      <TabPane tabId="2">
                        <Jogalap
                          {...this.props}
                          globals={this.props.globals}
                          ref={(instance) => { this.child2 = instance; }}
                          active={this.state.activeTab === '2'}
                        />
                      </TabPane>
                      <TabPane tabId="3">
                        <FunkcioJogalapOsszerendeles
                          {...this.props}
                          globals={this.props.globals}
                          ref={(instance) => { this.child3 = instance; }}
                          active={this.state.activeTab === '3'}
                        />
                      </TabPane>
                    </React.Fragment>
                  )}
                  {/* {this.props.globals.hasRole(['GDPRPROFIL']) && (
                    <TabPane tabId="4">
                      <Profil
                        {...this.props}
                        globals={this.props.globals}
                        ref={(instance) => { this.child4 = instance; }}
                        active={this.state.activeTab === '4'}
                      />
                    </TabPane>
                  )} */}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PartnerGDPRBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default PartnerGDPRBase;
